import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { StripeError } from '@stripe/stripe-js';
import { useState } from 'react';
import { BrowserView, isMobile } from 'react-device-detect';
import { AuthenticatedComponent, AuthenticatedKeycloak } from '../auth/keycloak';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileViewPage } from '../component/globalComponents/MobileViewPage';
import { BuyCurrency } from '../component/profileComponents/BuyCurrency';
import { Currency } from '../component/profileComponents/Currency';
import { GameProductList } from '../component/storeComponents/GameProductList';
import { BINGO_LICENSE, LEVIATHAN_LICENSE } from '../service/games';

export const StorePage: AuthenticatedComponent = ({ keycloak }) => {
    const [refreshFlag, setRefresh] = useState<boolean>(false);
    const [streamGold, setStreamGold] = useState<number>(0);
    const [refreshingGold, setRefreshingGold] = useState<boolean>(false);
    const [streamgoldLoaded, setStreamgoldLoaded] = useState<boolean>(false);
    const [bingoProductsLoaded, setBingoProductsLoaded] = useState<boolean>(false);
    const [leviathanProductsLoaded, setLeviathanProductsLoaded] = useState<boolean>(false);

    const renderContent = (keycloak: AuthenticatedKeycloak) => (
        <Flex className={isMobile ? 'store-container-mobile' : 'store-container-browser'}>
            <Flex className={'my-balance-container'}>
                <Flex className="my-balance">
                    <Currency
                        keycloak={keycloak}
                        refreshFlag={refreshFlag}
                        quantityCallback={(qty) => {
                            setStreamGold(qty);
                            setRefresh(false);
                        }}
                    />
                    {refreshingGold && <Spinner size={'xs'} />}
                </Flex>
            </Flex>
            <BuyCurrency
                keycloak={keycloak}
                refreshFlag={refreshFlag}
                loadCallback={() => setStreamgoldLoaded(true)}
                quantityCallback={(available) => {
                    setStreamGold(available);
                }}
                onPurchase={(err: StripeError | undefined) => {
                    setRefreshingGold(true);
                    setTimeout(() => {
                        setRefresh(true);
                        setRefreshingGold(false);
                    }, 5 * 1000);
                }}
            />
            <Flex className={'divider'} />
            <Flex className={'ingame-items-container'}>
                <Text className="ingame-game-title">The Bingo Room</Text>
                <GameProductList
                    keycloak={keycloak}
                    license={BINGO_LICENSE}
                    streamGoldBalance={streamGold}
                    onProductsLoaded={() => setBingoProductsLoaded(true)}
                    onPurchase={(success: boolean) => {
                        if (success) {
                            setRefresh(true);
                        }
                    }}
                />
                <Flex className={'divider'} />
                <Text className="ingame-game-title">Leviathan: Streams of Legends</Text>
                <GameProductList
                    keycloak={keycloak}
                    license={LEVIATHAN_LICENSE}
                    streamGoldBalance={streamGold}
                    onProductsLoaded={() => setLeviathanProductsLoaded(true)}
                    onPurchase={(success: boolean) => {
                        if (success) {
                            setRefresh(true);
                        }
                    }}
                />
                <Flex className={'divider'} />
            </Flex>
        </Flex>
    );

    return (
        <Box>
            <BrowserView>
                <BrowserTopBar
                    color="#FFF"
                    isLoading={
                        !leviathanProductsLoaded || !bingoProductsLoaded || !streamgoldLoaded
                    }
                    loadingColor={'#ed5b23'}
                >
                    <Flex className={'browser-view-title store-header'}>
                        <Text>STORE</Text>
                    </Flex>
                </BrowserTopBar>
                <BrowserSidebar />
                <Box className="browser-content">{renderContent(keycloak)}</Box>
            </BrowserView>
            <MobileViewPage
                title="STORE"
                titleBackgroundColor="#ED5B23"
                titleColor="#FFF"
                isLoading={!leviathanProductsLoaded || !bingoProductsLoaded || !streamgoldLoaded}
            >
                {renderContent(keycloak)}
            </MobileViewPage>
        </Box>
    );
};
